function normalizeCustoms(customs = {}) {
  return {
    resources: Array.isArray(customs.resources) ? customs.resources : [],
    supports: Array.isArray(customs.supports) ? customs.supports : []
  }
}

export function normalizeFooter(raw, { legacy = {} } = {}) {
  if (!raw || typeof raw !== 'object') {
    return {
      style: {},
      customs: { resources: [], supports: [] },
      legacy,
      isDefault: true
    }
  }
  const payload = raw.customsPayload ?? raw
  return {
    style: payload?.style ?? raw?.style ?? {},
    customs: normalizeCustoms(payload?.customs),
    legacy,
    isDefault: false
  }
}
